import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { IMetadataJSON } from '../../../components/TemplatesForms/Selector/types';
import RenderForm from '../../../components/TemplatesForms/RenderForm';
import { Button, Typography, Card, Divider } from '@mui/material';
import BackButton from '../../../components/Buttons/BackButton';
import { Box } from '@mui/system';
import HttpService from '../../../services/HttpService';
import { AutoCompleteInputOption } from '../../../components/Inputs/AutocompleteFreeSolo';
import { useSnackbar } from 'notistack';
import AsyncBackdropSubmit from '../../../components/AsyncBackdropSubmit';
import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TermsDialog from '../../../components/Dialog/TermsDialog';
export interface PreviewFormIncomingProps {
  formFields: IMetadataJSON[];
  formTitle: string;
  selectedOrganicUnit: AutoCompleteInputOption;
  selectedTomeas: AutoCompleteInputOption;
  formLanguage: AutoCompleteInputOption;
  selectedFormType: string
  emailForProtok: string;
  emailSubjectForProtocol: string;
  formDescription: string;
  checkboxes: {
    acceptPolicy: boolean;
    truthOnDetails: boolean;
  }

}
function NewFormPreview() {
  const location: { state: PreviewFormIncomingProps } = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [termsOpen, setTermsOpen] = React.useState<boolean>(false);
  const [checked, setChecked] = React.useState(false);

  const submitNewFormRequest = async () => {
    try {
      setIsLoading(true);
      await HttpService.getAxiosClient().post('/forms/', state);
      enqueueSnackbar('Το αίτημα σας υποβλήθηκε επιτυχώς', { variant: 'success' });
      navigate('/admin/applications');
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Υπήρξε κάποιο πρόβλημα με την υποβολή του αιτήματος', { variant: 'error' });
    }
  };

  const navigateBackToNewForm = () => {
    navigate('/admin/applications/new-form', { state: { ...state } });
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleClickOpen = () => {
    setTermsOpen(true);
  };
  useEffect(() => {
    if (!state.formFields) {
      navigate('/admin/applications/new-form');
    }
  });

  return (
    <>
      <AsyncBackdropSubmit isLoading={isLoading}>
        Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
      </AsyncBackdropSubmit>
      <Typography variant='h2'>Προβολή Αιτήματος</Typography>
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigateBackToNewForm()} />
      </Box>
      <Card style={{
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        padding: '16px',
        minWidth: '358px'
      }}>
        <Typography variant='h3' sx={{ display: 'flex', justifyContent: 'center' }}>
          {state.formTitle}
        </Typography>
        <Divider sx={{ m: 3 }} />
        <Box p={2}>
          <Typography mb={4}
            variant='h4'>{state.formDescription}</Typography>
          <RenderForm disabled={true}
            metadataArray={state?.formFields || []} />
          <Box mt={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleCheckboxChange} />
              }
              label={
                <>
                  <Button onClick={handleClickOpen}>Αποδοχή όρων Χρήσης & Ορθότητας Στοιχείων
                  </Button>
                  <TermsDialog open={termsOpen} handleClose={() => setTermsOpen(false)}
                    onAccept={() => {
                      setTermsOpen(false);
                      setChecked(true);
                    }}
                    onDecline={() => setChecked(false)} />
                </>
              } />
          </Box>
        </Box>
      </Card>
      <Box mt={6} display='flex'
        justifyContent='flex-end'>
        <Button onClick={navigateBackToNewForm}>Επιστροφή</Button>
        <Button
          variant='contained'
          color='primary'
          onClick={submitNewFormRequest}>Δημιουργία Αιτήματος/Φόρμας</Button>
      </Box>
    </>
  );
} export default NewFormPreview;